module.exports = __webpack_public_path__ + "img/login_tab03_03.f624f192.png";